import { createContext } from "react";

export interface Actions {}

export interface ContextType {
	token: string;
}

const defaultContextValues: ContextType = {
	token: ""
};

export default createContext<ContextType>(defaultContextValues);
